import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, Permission } from '../../shared/config';
import { BookingService } from '../../booking/models/booking.service';
import { NormalBookingList } from '../../booking/models/normal-booking-list.model';

@Component({
  selector: 'wego-snail-trail-booking-popup',
  template: require('../views/snail-trail-booking-popup.component.html'),
  providers: [BookingService]
})

export class SnailTrailBookingPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  bookingList: NormalBookingList[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('bookingModal') public bookingModal: any;

  constructor(private bookingService: BookingService    
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["driver", "bookingReferenceID", "licenceTag","translatedBookingStatus"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetBookingList();
    this.bookingModal.show();
  }

  public hide(): void {
    this.bookingModal.hide();
  }

  private GetBookingList() {
    this.isLoading = true;
    this.bookingService.GetNormalBookingList(this.DataListModel, true, Permission.PR_SANIL_TRAIL_REPORT)
      .subscribe(
      res => {
        this.bookingList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(booking: NormalBookingList): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({ BookingHashID: booking.bookingHashId, BookingReferenceId: booking.bookingReferenceID,
      DriverHashID:booking.driverHashId,DriverName:booking.driver,LicenceTage:booking.licenceTag,VehicleMasterHashID:booking.vehicleHashId});
    this.isLoading = false;
    this.hide();
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetBookingList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetBookingList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetBookingList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetBookingList();
  }
  private OnSuccessSelect() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/snail-trail/components/snail-trail-booking-popup.component.ts